export function createSubmitCycle({ hasImage, wasOnboarding }) {
  return {
    hasImage,
    wasOnboarding,
    profileDone: false,
    profileFailed: false,
    imageDone: false,
    imageFailed: false,
  };
}

export function markSubmitCycleEvent(cycle, event) {
  const next = { ...cycle };

  switch (event) {
    case "profileSuccess":
      next.profileDone = true;
      break;
    case "profileError":
      next.profileFailed = true;
      break;
    case "imageSuccess":
      next.imageDone = true;
      break;
    case "imageError":
      next.imageFailed = true;
      break;
    default:
      break;
  }

  return next;
}

export function isSubmitCycleResolved(cycle) {
  const profileResolved = cycle.profileDone || cycle.profileFailed;

  if (!cycle.hasImage) {
    return profileResolved;
  }

  const imageResolved = cycle.imageDone || cycle.imageFailed;
  return profileResolved && imageResolved;
}

export function getSubmitCycleFeedback(cycle) {
  if (!isSubmitCycleResolved(cycle)) {
    return null;
  }

  if (!cycle.hasImage) {
    if (cycle.profileDone) {
      return { kind: "success", shouldNavigate: true };
    }
    return null;
  }

  if (cycle.profileFailed) {
    return null;
  }

  if (cycle.profileDone && cycle.imageDone) {
    return { kind: "success", shouldNavigate: true };
  }

  if (cycle.profileDone && cycle.imageFailed) {
    return { kind: "warning", shouldNavigate: false };
  }

  return null;
}
